import { Bell, Mail, Smartphone, Globe } from 'lucide-react';

interface NotificationSettingsProps {
  isGlobalDarkMode: boolean;
}

export const NotificationSettings: React.FC<NotificationSettingsProps> = ({ isGlobalDarkMode: _ }) => {
  const toggleClass = "w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-workspace-accent/30 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-workspace-accent";

  return (
    <div className="space-y-6">
      {/* Email Notifications Card */}
      <div className="rounded-lg border p-6 bg-card border-border">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-lg bg-info/15 text-info">
            <Mail className="w-5 h-5" />
          </div>
          <h3 className="text-lg font-semibold text-foreground">Email Notifications</h3>
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-foreground">Brand Updates</p>
              <p className="text-sm text-muted-foreground">Get notified when your brands are updated</p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" className="sr-only peer" defaultChecked />
              <div className={toggleClass}></div>
            </label>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-foreground">Team Activity</p>
              <p className="text-sm text-muted-foreground">Notifications about team member actions</p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" className="sr-only peer" defaultChecked />
              <div className={toggleClass}></div>
            </label>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-foreground">Security Alerts</p>
              <p className="text-sm text-muted-foreground">Important security notifications</p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" className="sr-only peer" defaultChecked />
              <div className={toggleClass}></div>
            </label>
          </div>
        </div>
      </div>

      {/* Push Notifications Card */}
      <div className="rounded-lg border p-6 bg-card border-border">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-lg bg-success/15 text-success">
            <Smartphone className="w-5 h-5" />
          </div>
          <h3 className="text-lg font-semibold text-foreground">Push Notifications</h3>
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-foreground">Desktop Notifications</p>
              <p className="text-sm text-muted-foreground">Show notifications on your desktop</p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" className="sr-only peer" />
              <div className={toggleClass}></div>
            </label>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-foreground">Sound Alerts</p>
              <p className="text-sm text-muted-foreground">Play sound for notifications</p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" className="sr-only peer" />
              <div className={toggleClass}></div>
            </label>
          </div>
        </div>
      </div>

      {/* Marketing Notifications Card */}
      <div className="rounded-lg border p-6 bg-card border-border">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-lg bg-warning/15 text-warning">
            <Globe className="w-5 h-5" />
          </div>
          <h3 className="text-lg font-semibold text-foreground">Marketing & Updates</h3>
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-foreground">Product Updates</p>
              <p className="text-sm text-muted-foreground">New features and improvements</p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" className="sr-only peer" />
              <div className={toggleClass}></div>
            </label>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-foreground">Newsletter</p>
              <p className="text-sm text-muted-foreground">Weekly tips and industry news</p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" className="sr-only peer" />
              <div className={toggleClass}></div>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};
